<div class="container-fluid bg-white px--0 py--lg-48 py--24">
    <app-section-title [title]="'page.dashboard-dynamic.freetrials.title' | translate" [subtitle]="'page.dashboard-dynamic.freetrials.description' | translate" [sectionclass]="'container mb--lg-48 mb--24 text-center'"></app-section-title>
    <div class="container text-center">
        <div class="d-flex flex-column flex-lg-row gap-24 mb--24">
            <div class="product-trial text-center" *ngFor="let product of productTrials; trackBy: trackByFn">
                <img [ngSrc]="product.image" width="56" height="56" [attr.alt]="'free trial'" priority class="product-thumb">
                <h5 class="mt--24">{{ product.title }}</h5>
                <div class="promo-description mb--24">{{ product.description | translate }}</div>
                <button mat-flat-button color="primary" class="p--24 p--lg-24 m--auto" (click)="goToProduct(product.sku)">{{ 'Scopri di più' | translate }}</button>
            </div>
        </div>
        <!-- <button mat-flat-button color="primary" class="p--24 p--lg-24 m--auto" (click)="goToMarketplace()">{{ 'freetrials.ctabutton' | translate }}</button>   -->
    </div>
</div>
